import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import { Table } from "antd";
import BaseCard from "../../components/card/BaseCard";
import { Icon } from "@iconify/react";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import ButtonIcon from "../../components/ButtonIcon";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Link, useParams } from "react-router";
import { $api, type components } from "../../helper";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { statusMock, tokenMock } from "../../helper/mock";
import { useNotify } from "../../helper/notify";
import FilterSearch from "../../components/filter/FilterSearch";
import StatusVisit from "../../components/StatusVisit";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function VideoList() {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const params = useParams();
  const [id, setId] = useState("");
  const detail = $api.useQuery("get", "/site-api/v1/course-season-detail/", {
    params: {
      query: {
        season_u_id: params.id ?? "",
      },
    },
    headers: {
      Authorization: tokenMock,
      lang: "fa",
    },
  });
  const { data, isPending, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/course-season-video/",
    {
      params: {
        query: {
          season_u_id: params.id ?? "",
        },
      },
    },
  );
  const removeCategory = $api.useMutation(
    "delete",
    "/site-api/v1/course-season-video/",
  );
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ویدیو ها");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteCourseSeasonVideoItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "عنوان ویدیو",
      dataIndex: "title",
      key: "title",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.title
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "مدت زمان ویدیو",
      dataIndex: "duration",
      key: "duration",
    },
    {
      title: "ترتیب نمایش",
      dataIndex: "display_order",
      key: "display_order",
    },
    {
      title: "نمایش در سایت",
      key: "show",
      dataIndex: "show",
      filters: statusMock,
      onFilter: (value, record) =>
        record.status.toString().indexOf(value as string) === 0,
      render: (_, record) => <StatusVisit status={record.status} />,
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonLinkIcon
            to={{
              pathname: `/add-video-for-season/${params.id}`,
              search: "?u_id=" + record.u_id,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={{
              pathname: `/add-video-for-season/${params.id}`,
              search: "?u_id=" + record.u_id,
            }}
            className="text-primary-500!"
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        pending={removeCategory.isPending}
        title="حذف از ویدیو ها ؟"
        description="حذف این ویدیو باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          removeCategory.mutate(
            {
              params: {
                query: {
                  video_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                setIsOpen(false);
                notify.success(data.message);
                setId("");
                refetch();
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <div className="w-full flex justify-between sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <CustomBreadcrumb
          items={[
            {
              title: "لیست دوره ها",
              href: "/courses",
            },
            {
              title: detail?.data?.data?.course_title,
              href: `/list-of-seasons/${detail?.data?.data?.course_u_id}`,
            },
            {
              title: detail?.data?.data?.title,
            },
          ]}
        />
        <Link
          to={`/add-video-for-season/${params.id}/?season_name=${detail?.data?.data?.title}`}
          className="button-style"
        >
          ایجاد ویدیو
        </Link>
      </div>

      <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
        <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
          <Table<components["schemas"]["SiteCourseSeasonVideoItem"]>
            columns={columns}
            dataSource={data?.data}
            loading={isPending}
            className="col-span-1!"
            scroll={{ x: "max-content" }}
          />
        </BaseTable>
      </BaseCard>
    </div>
  );
}
